import React from 'react';
import PropTypes from 'prop-types';
import { CallToAction } from '@americanexpress/dls-react';

const SlideButton = ({
  id,
  analyticDetail,
  analyticElement,
  ctaLink,
  ctaText,
}) => {
  if (!ctaLink || !ctaText) {
    return null;
  }

  return (
    <CallToAction
      id={id}
      variant="primary"
      href={ctaLink}
      rel="noopener noreferrer"
      identifier={analyticDetail}
      reactlytics={{
        element: analyticElement,
        detail: analyticDetail,
      }}
    >
      {ctaText}
    </CallToAction>
  );
};

SlideButton.propTypes = {
  id: PropTypes.string.isRequired,
  analyticDetail: PropTypes.string.isRequired,
  analyticElement: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
};

export default SlideButton;
